let defaultQueryString = ''

// 初始化固定参数
export const initDefaultParams = (query) => {
    defaultQueryString = JSON.stringify(query)
    localStorage.setItem('landing_default_params', defaultQueryString)
}

// 单个固定自定义参数
export const addDefaultParams = (key, val) => {
    const defaultQuery = JSON.parse(defaultQueryString) || {}
    defaultQueryString = JSON.stringify(Object.assign(defaultQuery, {
        [key]: val
    }))
    localStorage.setItem('landing_default_params', defaultQueryString)
}

// 获取初始化参数
export const getDefaultParams = () => {
    // 先尝试从defaultQueryString中去取 如果没有的话从localStorage中去获取
    if (defaultQueryString && defaultQueryString.length) {
        return JSON.parse(defaultQueryString)
    } else {
        return JSON.parse(localStorage.getItem('landing_default_params') || '{}')
    }
}

// 比较currentParams 是否包含targetParams
export const compareParams = (currentParams, targetParams) => {
    let flag = true
    for (const key in targetParams) {
        if (!Reflect.has(currentParams, key)) {
            flag = false
            break
        }
    }
    return flag
}
